import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Input,
  Button,
  FormControl,
  FormLabel,
  useDisclosure,
  Box,
  Center,
  VStack,
  HStack,
} from "@chakra-ui/react";
import React, { useState } from "react";
import axios from "axios"
import { useToast } from '@chakra-ui/react'

export default function ScholarshipModal({props}) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [fees, setFees] = useState("");
  const [examDate, setExamDate] = useState("");
  const [examStart, setExamStart] = useState("");
  const [examEnd, setExamEnd] = useState("");
  const [benefits, setBenefits] = useState("");

  const handleSave = async() => {
    console.log("K")
    const res = await axios.post("http://localhost:8000/api/scholashipcategory/edit", {
      id: props.id,
      examDate: examDate,
      examStart: examStart,
      examEnd: examEnd,
    });
    onClose(); // Close the modal after saving
  };

  

  return (
    <Box >
      <Box
        
       
       
        p="10px"
        borderRadius={"lg"}
        m="10px"
      >
        <VStack>
          <Center >
          <Button w="full" fontFamily={"cursive"} onClick={onOpen} colorScheme="teal" >
        Scholarship Program{props.name} fees
            </Button>
          </Center>
          <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
           
              <ModalHeader> Scholarship Program{props.name} fees</ModalHeader>
            
              <ModalCloseButton />
              <ModalBody>
                <VStack>
                  
                  <FormControl>
                    <HStack w="300px">
                      <FormLabel>Exam Date</FormLabel>
                      <Input
                        type="date"
                        value={examDate}
                        onChange={(e) => setExamDate(e.target.value)}
                      />
                    </HStack>
                  </FormControl>
                  <FormControl>
                    <HStack w="300px">
                      <FormLabel>Exam Start</FormLabel>
                      <Input
                        type="time"
                        value={examStart}
                        onChange={(e) => setExamStart(e.target.value)}
                      />
                    </HStack>
                  </FormControl>
                  <FormControl>
                    <HStack w="300px">
                      <FormLabel>Exam End</FormLabel>
                      <Input
                        type="time"
                        value={examEnd}
                        onChange={(e) => setExamEnd(e.target.value)}
                      />
                    </HStack>
                  </FormControl>
                 
                </VStack>
              </ModalBody>
              <ModalFooter>
                <Button colorScheme="teal" onClick={handleSave} mx="10px">
                  Save
                </Button>
                <Button colorScheme="teal" onClick={onClose} mx="10px">
                  Close
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </VStack>
      </Box>
      
    </Box>
  );
}
